import { match } from 'ts-pattern'

import spicyChain from './networks/spicy'
import mainnetChain from './networks/mainnet'
import stagingChain from './networks/staging'

export function getMaxSupply() {
	return match(import.meta.env.VITE_ENV)
		.with('integration', () => stagingChain.maxSupply)
		.with('staging', () => stagingChain.maxSupply)
		.with('spicy', () => spicyChain.maxSupply)
		.otherwise(() => mainnetChain.maxSupply)
}
